import React, { useState } from "react";
import { Col, Container, Row, Modal } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import BannerForm from "../../components/bannerfrom";
import { Link } from "gatsby";
import {
  Feature1,
  Feature2,
  Feature3,
  Feature4,
  Feature5,
  Feature6,
  Feature7,
  Feature8,
  Feature9,
} from "../../../../app-constants";

function FeatureNew(props) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const slides = [
    Feature1,
    Feature2,
    Feature3,
    Feature4,
    Feature5,
    Feature6,
    Feature7,
    Feature8,
    Feature9,
  ];

  //Function to generate duplicated slides for looping
  const generateDuplicatedSlides = (slides, count) => {
    const duplicatedSlides = [];
    for (let i = 0; i < count; i++) {
      duplicatedSlides.push(...slides);
    }
    return duplicatedSlides;
  };

  // Duplicate the slides to ensure continuous looping (adjust 'count' as needed)
  const duplicatedSlides = generateDuplicatedSlides(slides, 50);

  return (
    <>
      <div className="feature_sec_lp hv-100">
        <Container className="h-100">
          <Row className="h-100">
            <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="my-auto">
              <Row>
                <Col
                  xs={12}
                  md={12}
                  lg={11}
                  xl={9}
                  xxl={9}
                  className="mx-auto text-center"
                >
                  <h2>
                    Trusted Excellence: Leading Web Development Company
                    Recognized by Industry Leaders
                  </h2>
                  <p>
                    We're a top-notch web development company, praised by
                    numerous firms for our exceptional work. Our dedication to
                    excellence has earned us widespread recognition, making us a
                    trusted choice in the industry.
                  </p>
                  <Link
                    to=""
                    className="lp_btn"
                    aria-label="TekRevol Contact"
                    onClick={handleShow}
                  >
                    Let’s Talk
                  </Link>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
                  <Swiper
                    loop={true}
                    navigation={true}
                    autoplay={{
                      delay: 2500,
                      disableOnInteraction: false,
                    }}
                    modules={[Navigation, Autoplay]}
                    breakpoints={{
                      320: {
                        slidesPerView: 3,
                      },
                      768: {
                        slidesPerView: 3,
                      },
                      1024: {
                        slidesPerView: 4,
                      },
                      1366: {
                        slidesPerView: 4,
                      },
                    }}
                    className="carousel_featured_new"
                  >
                    {duplicatedSlides.map((slide, index) => (
                      <SwiperSlide key={index}>
                        <div className="featured_item">
                          <div className="featured_img">{slide}</div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="landing_lp_popup"
      >
        <div className="modal_forms">
          <BannerForm setShow={setShow} />
        </div>
      </Modal>
    </>
  );
}

export default FeatureNew;
